import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { StorageService } from 'src/app/_services/storage.service';
import { Subscription } from 'rxjs';
import { Routes } from 'src/app/_config/routes.config';
import { AuthService } from 'src/app/_services/auth.service';
import { User } from 'src/app/_models/user.model';

@Component({
  selector: 'DCO-sso.component',
  templateUrl: './sso.component.html',
  standalone: false,
})
export class SsoComponent extends BaseComponent implements OnInit {
  ssoError: Boolean = false;
  isLoggedIn: Boolean = false;
  page: string;
  private userSuscription!: Subscription;
  private authErrors!: Subscription;
  lstErrors = new Array();

  constructor(
    public override router: Router,
    public override langService: LanguageManagerService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private storageService: StorageService,
  ) {
    super(router, langService, route);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.userSuscription = this.storageService.userInfo.subscribe((user) => {
      this.isLoggedIn = user != null;
      this.updateUserData(user);
    });
    this.authErrors = this.authService.authError$.subscribe((message) => {
      this.ssoError = true;
      this.lstErrors.push(message);
    });
    this.route.queryParams.subscribe((params: Params) => {
      if (params.hasOwnProperty('sessionid') && params['sessionid'] != '') {
        this.CallSSO(params['sessionid']);
      } else {
        this.ssoError = true;
      }
    });
  }
  private CallSSO(sessionId) {
    this.lstErrors = [];
    this.authService.loginSSO(sessionId).catch((err) => {
      this.ssoError = true;
    });
  }
  updateUserData(user: User) {
    if (user != null) {
      let tokenData = this.authService.getTokenData();
      if (tokenData.enrollment == 'True') {
        this.page = Routes.DISPUTES;
      } else {
        // console.log('El usuario NO tiene realizado el enrollment');
        this.page = Routes.ENROLLMENT;
      }
      this.router.navigate([this.page]);
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }
}
